import React, { useCallback, useMemo } from 'react';
import { convertMarkdownToProsemirror } from '@atlassian/ai-model-io/convert-markdown-to-prosemirror';
import { useAgentsList } from '@atlassian/conversation-assistant-agent';
import { useSubscribe } from '@atlassian/conversation-assistant-pubsub';
import { getEditorAgent } from '@atlassian/generative-ai-modal/utils/agents';
import { beforeDispatchAIRovoAgentTransaction, insertAIContentAtCurrentPosition, replaceWithAIContent } from '../../../prebuilt/config-item-actions/action-utils';
import { mapToConvoAIProductName } from '../../../provider/prompt-requests/utils/get-convoai-supported-product-name';
import { isLastActiveEditorView, useTrackLastActiveEditorView } from './utils';
export var SubscribeToRovo = function SubscribeToRovo(_ref) {
  var editorView = _ref.editorView,
    product = _ref.product,
    onDocChangeByAgent = _ref.onDocChangeByAgent;
  var agents = useAgentsList({
    product: mapToConvoAIProductName(product)
  });
  var topic = useMemo(function () {
    return {
      topic: 'ai-mate'
    };
  }, []);
  useTrackLastActiveEditorView(editorView);
  var callback = useCallback(function (payload) {
    if (payload.type === 'editor-suggestion' && isLastActiveEditorView(editorView)) {
      var state = editorView.state;
      switch (payload.data.mode) {
        case 'insert':
          {
            var _convertMarkdownToPro = convertMarkdownToProsemirror({
                markdown: payload.data.content,
                schema: state.schema,
                idMap: {}
              }),
              pmFragment = _convertMarkdownToPro.pmFragment;
            var tr = insertAIContentAtCurrentPosition({
              editorView: editorView,
              positions: [state.selection.from, state.selection.to],
              pmFragment: pmFragment
            });
            beforeDispatchAIRovoAgentTransaction(tr);
            editorView.dispatch(tr);
            editorView.focus();
            break;
          }
        case 'replace':
          {
            var _convertMarkdownToPro2 = convertMarkdownToProsemirror({
                markdown: payload.data.content,
                schema: state.schema,
                idMap: {}
              }),
              _pmFragment = _convertMarkdownToPro2.pmFragment;
            var _tr = replaceWithAIContent({
              editorView: editorView,
              positions: [state.selection.from, state.selection.to],
              pmFragment: _pmFragment,
              options: {
                replaceDocOnEmptySelection: false
              }
            });
            beforeDispatchAIRovoAgentTransaction(_tr);
            editorView.dispatch(_tr);
            editorView.focus();
            break;
          }
      }
      var matchedAgent = agents.find(function (agent) {
        return agent.id === payload.data.agentId;
      });
      if (matchedAgent && onDocChangeByAgent) {
        var agent = getEditorAgent(matchedAgent);
        onDocChangeByAgent(agent);
      }
    }
  }, [agents, onDocChangeByAgent, editorView]);
  useSubscribe(topic, callback);
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};